export default __webpack_public_path__ + "static/media/037-turn.82509503.png";